<template>
  <div class="select-6 flex-vh-center">
      <span class="bottom-words" @click="tolink">浙ICP备2020030893号 杭州享点网络科技有限公司</span>
  </div>
</template>

<script>
import { slideTo } from "../../utils";
export default {
  name: "selectSix",
  data() {
    return {
      isScroll: false
    };
  },
  methods: {
    toTop() {
      slideTo(0, true);
      this.isScroll = false;
    },
    tolink(){
      window.open('https://beian.miit.gov.cn')
    }
  },
  created() {
    window.addEventListener("scroll", e => {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
        this.isScroll = scrollTop > 100;
    });
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/index.scss";
.select-6 {
  position: relative;
  width: 100%;
  height: 57px;
  background: RGBA(0, 27, 105, 1);
  .componay-info {
    position: relative;
    text-align: center;
    padding-right: 123px;
    img {
      width: 195px;
      height: 105px;
    }
    p {
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(159, 159, 159, 1);
      margin-top: 12px;
    }
  }
  .concat-info{
    position: relative;
    margin-right: 133px;
    &:after{
      position: absolute;
      right: -65px;
      top: 10px;
      content: '';
      width: 2px;
      height: 110px;
     border-right: 1px dashed #fff;
    }
  }
  .concat-with-us {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(231, 231, 231, 1);
    margin-left: 178px;
    margin-top: 44px;
    margin-bottom: 20px;
  }
  .ad-form {
    padding-left: 80px;
    position: relative;
  }
  .m-form {
    margin-left: 80px;
  }

  .form {
    display: inline-block;
    p {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 800;
      color: rgba(0, 0, 0, 1);
      margin-bottom: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      text-align: center;
      color: rgba(202, 202, 202, 1);
    }
    div {
      margin-bottom: 6px;
      font-size: 11px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(184, 184, 184, 1);
    }
    .btn-submit {
      width: 254px;
      height: 30px;
      background: rgba(0, 96, 217, 1);
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 30px;
      text-align: center;
      margin-top: 19px;
      cursor: pointer;
    }
  }
}
.left {
  display: inline-block;
  margin-right: 20px;
}
.left-row {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  span:nth-child(1) {
    display: inline-block;
    width: 18px;
    height: 18px;
    font-size: 16px;
    margin-right: 10px;
  }
  .icon-user {
    background: url(../../assets/images/yonghu.png) no-repeat;
    background-size: 100% 100%;
  }
  .icon-email {
    background: url(../../assets/images/youxiang.png) no-repeat;
    background-size: 100% 100%;
  }
  .icon-tel {
    background: url(../../assets/images/weibiaoti-.png) no-repeat;
    background-size: 100% 100%;
  }
}
.img_wx {
  margin-top: 20px;
  img {
    width: 100px;
    height: 100px;
  }
}
input {
  width: 247px;
  height: 30px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(184, 184, 184, 1);
  padding-left: 6px;
}
input:focus {
  border-color: #3660d9;
}
.bottom-words {
  cursor: pointer;
  text-align: center;
  color: #fff;
  bottom: 50px;
}
.to-top {
  width: 60px;
  height: 60px;
  position: fixed;
  bottom: 160px;
  right: 30px;
  cursor: pointer;
  animation: top-move 0.45s infinite alternate;
  img {
    width: 100%;
    height: 100%;
  }
  @keyframes top-move {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(20px);
    }
  }
}
</style>